import { createRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Route as appRoute } from '../../_app'
import { useRequireAdmin } from '../../../lib/me-context'
import { AdminShell } from '../../../components/admin/AdminShell'
import { AdminUserTable } from '../../../components/admin/AdminUserTable'

/**
 * Admin user management (`/admin/users`) — find a user and take a safe
 * administrative action (disable/enable, grant/revoke admin). Guarded by
 * {@link useRequireAdmin}.
 */
export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: '/admin/users',
  component: AdminUsersPage,
})

function AdminUsersPage() {
  const { t } = useTranslation('admin')
  const isAdmin = useRequireAdmin()

  if (!isAdmin) {
    return null
  }

  return (
    <AdminShell active="users" title={t('usersTitle')}>
      <AdminUserTable />
    </AdminShell>
  )
}
